import {
  VENDOR_ROLE,
  CLIENT_ROLE,
  ADMIN_ROLE,
  UNKNOWN_ROLE
} from "@/services/constants";
import { getCurrentUser } from "@/services/shared";
import { VendorRoutes, defaultVendorRoute } from "./vendor-routes";
import { ClientRoutes, defaultClientRoute } from "./client-routes";
import { AdminRoutes, defaultAdminRoute } from "./admin-routes";
import { UniversalRoutes, defaultUniversalRoute } from "./universal-routes";

// configurable default routes
const DefaultRoutes = {
  [VENDOR_ROLE]: defaultVendorRoute,
  [CLIENT_ROLE]: defaultClientRoute,
  [ADMIN_ROLE]: defaultAdminRoute,
  [UNKNOWN_ROLE]: defaultUniversalRoute
};

//Will NAVIGATE to default route for users not logged in
export const getDefaultRoute = () => {
  const user = getCurrentUser();

  const role = Symbol.for(user.role);

  //If we are getting the default route for an anonymous user, we are going to use it, so we might as well redirect here.
  //  Otherwise, it's going to take several seconds and they will see an intermediate page... it will work that way though. This is for UX.
  if (role === UNKNOWN_ROLE) {
    window.location = DefaultRoutes[role].href; //was DefaultRoutes[role].meta.redirect but im hoping this works
  }

  if (user) {
    return DefaultRoutes[Symbol.for(user.role)] || defaultUniversalRoute;
  }
};

const routes = [
  ...VendorRoutes,
  ...ClientRoutes,
  ...UniversalRoutes,
  ...AdminRoutes,
  // Lowest Priority route. Keep at bottom of array so this doesn't override any other route
  {
    path: "*",
    redirect: getDefaultRoute
  }
];

const navBarItem = route => {
  return route.meta && route.meta.navbarMenu
    ? {
        ...route.meta.navbarMenu,
        path: route.path,
        featureFlaggedOnBy: route.meta.featureFlaggedOnBy,
        featureFlaggedOffBy: route.meta.featureFlaggedOffBy
      }
    : null;
};

const VendorNavBarItems = VendorRoutes.map(navBarItem).filter(it => it != null);
const ClientNavBarItems = ClientRoutes.map(navBarItem).filter(it => it != null);
const AdminNavBarItems = AdminRoutes.map(navBarItem).filter(it => it != null);
const UniversalNavBarItems = UniversalRoutes.map(navBarItem).filter(
  it => it != null
);

const hasPermission = (user, route) => {
  //roles are taken care of elsewhere
  if (!route.permission) return true;

  for (const [permissionKey, requiredValue] of Object.entries(
    route.permission
  )) {
    if (user["has" + permissionKey] !== requiredValue) {
      return false;
    }
  }

  return true;
};

export const getNavBarItems = () => {
  const user = getCurrentUser();
  if (!user) return [];
  let items = [];
  let appearsAsClient =
    Symbol.for(user.role) === CLIENT_ROLE ||
    (Symbol.for(user.role) === ADMIN_ROLE && user.assumedRole === CLIENT_ROLE);
  let appearsAsVendor =
    Symbol.for(user.role) === VENDOR_ROLE ||
    (Symbol.for(user.role) === ADMIN_ROLE && user.assumedRole === VENDOR_ROLE);

  if (appearsAsClient) {
    //filter out attestations, if not dentaquest
    if (user.clientId !== 604) {
      items = ClientNavBarItems.filter(it => it.name !== "Attestations");
    } else {
      items = ClientNavBarItems;
    }
  } else if (appearsAsVendor) items = VendorNavBarItems;

  if (Symbol.for(user.role) === ADMIN_ROLE)
    items = items.concat(AdminNavBarItems);

  if (Symbol.for(user.role) !== UNKNOWN_ROLE)
    items.concat(UniversalNavBarItems);

  items = items.filter(rt => hasPermission(user, rt));

  return items.sort((a, b) => a.order - b.order);
};

export default routes;
